export const isServiceInactive = (status?: string) => {
  return !status || ["Terminated", "Cancelled"].includes(status);
};
